import { render } from "./fileDropperWithPreview.vue?vue&type=template&id=45beb4f9&scoped=true&ts=true"
import script from "./fileDropperWithPreview.vue?vue&type=script&lang=ts"
export * from "./fileDropperWithPreview.vue?vue&type=script&lang=ts"

import "./fileDropperWithPreview.vue?vue&type=style&index=0&id=45beb4f9&scoped=true&lang=css"

import exportComponent from "C:\\projects\\totalrender\\onofficeapp\\marketplaceapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45beb4f9"]])

export default __exports__